<template>
  <div class="index">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row>
              <el-col>
                <el-form
                  ref="formData"
                  :model="formData"
                  :rules="rules"
                  label-width="100px"
                  class="demo-ruleForm">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        label="名称"
                        prop="title">
                        <el-input v-model="formData.title"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="链接">
                        <el-input v-model="formData.url"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="权限url">
                        <el-input v-model="formData.rule_url"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="同级排序">
                        <el-input v-model="formData.sort"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="导航分组">
                        <el-input v-model="formData.group"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="分组必要字段">
                        <el-input v-model="formData.group_limit_field"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="菜单隐藏">
                        <el-switch
                          active-text="隐藏"
                          inactive-text="显示"
                          active-value="1"
                          inactive-value="0"
                          v-model="formData.hide"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="访问限制">
                        <el-switch
                          active-text="允许"
                          inactive-text="禁止"
                          active-value="1"
                          inactive-value="0"
                          v-model="formData.status"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="submitForm('formData')">立即创建</el-button>
                      <!--<el-button @click="resetForm('ruleForm')">重置</el-button>-->
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';

export default {
  data() {
    return {
      formData: {
        pid: this.$route.params.pid,
        title: '',
        url: '',
        rule_url: '',
        sort: 0,
        group: '',
        group_limit_field: '',
        hide: '0',
        status: '1'
      },
      rules: {
        title: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {},
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (typeof this.formData.pid === 'undefined') {
            this.formData.pid = 0;
          }
          this.$http._post({
            url: '/interview/Power/menuAdd',
            data: this.formData,
          }).then((res) => {
            if (res.result === 0) {
              this.$message({
                type: 'success',
                message: '创建成功!'
              });
              this.$router.push({ name: 'menu', params: { pid: this.formData.pid } });
            }
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
  },
  watch: {

  },
};
</script>
